import styled from 'styled-components';

export const FormElement = styled('form')`
  display: flex;
  flex-direction: column;
  width: 450px;
  margin-top: 16px;

  & > * {
    margin-bottom: 24px;
    width: 100%;
  }

  & > button {
    margin-top: 4px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;
